import { ChartsDemo } from "@/components/crm-demos/charts-demo"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_crm-demos/charts-demo")({
  component: ChartsDemoPage,
  head: () => ({ meta: [{ title: "Charts" }] }),
});

function ChartsDemoPage() {
  return <ChartsDemo />
}
